module.exports = __webpack_public_path__ + "img/jth-2.890a345e.png";